import {Component, OnInit} from '@angular/core';
import {DownloadCenterDocument} from '../domains/common.domain';
import {DownloadCenterService} from '../services/download-center.service';

@Component({
  selector: 'app-download-center',
  templateUrl: './download-center.component.html',
  styleUrls: ['./download-center.component.scss']
})
export class DownloadCenterComponent implements OnInit {

  documents: any;
  isLoading: boolean;

  constructor(private downloadCenterService: DownloadCenterService) {
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.downloadCenterService.getAllData('documents').subscribe((documents: DownloadCenterDocument) => {
      this.documents = documents.document;
      this.isLoading = false;
    });
  }

  downloadFile(documentId: string, fileName: string): void {
    this.downloadCenterService.readDocument(documentId).subscribe((response: Blob) => {
      this.downloadCenterService.downloadDocument(response, fileName);
    });
  }
}
